import styles from './ClientOrderList.module.css'
import ModalWindow from "../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import React, {useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {AddFeedBackInt} from "./ClientOrderList";
interface ClientOrderRefundPropsInt
{
    orderId:string
    author: string
    defPhone: string
    defEMail: string
    onClose:()=>void
}
export default function ClientOrderRefund({orderId,onClose,author, defPhone,defEMail}:ClientOrderRefundPropsInt){
    const appealErrorLine = useRef<ErrorLineItemRef>(null)

    const [phone, setPhone] = useState(defPhone)
    const [eMail, setEMail] = useState(defEMail)
    const [appeal, setAppeal] = useState("")
    const [payData, setPayData] = useState("")

    const addFeedBackData = useRef<AddFeedBackInt>()
    const [ldrAddFeedback,rsAddFeedback,exAddFeedback] = useApiQuery("/appeal/add","post",addFeedBackData);


    const handleSendAppeal = () =>{
        if(appeal?.length < 5 )
        {
            if(appealErrorLine.current)appealErrorLine.current.show("Не корретная причины возврата", true,2000)
            return
        }
        if(payData.length < 5 )
        {
            if(appealErrorLine.current)appealErrorLine.current.show("Не корректные платежные реквизиты ", true,2000)
            return
        }
        if( !phone?.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui))
        {
            if(appealErrorLine.current)appealErrorLine.current.show("Не корректный телефон",true,2000)
            return;
        }
        if( !eMail?.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ui))
        {
            if(appealErrorLine.current)appealErrorLine.current.show("Не корректный e-Mail",true,2000)
            return;
        }



        addFeedBackData.current = {
            type: 4,
            author: author,
            parent: 0,
            xData: orderId,
            yData: payData,
            text: appeal,
            capt:"",
            phone: phone,
            eMail: eMail
        }
        exAddFeedback().then((e)=>{
            if(e?.success)
            {
                if(appealErrorLine.current)appealErrorLine.current.show("Обращение отправлено", false,2000)
                setTimeout(()=>onClose(),2000)
                return
            }
            if(appealErrorLine.current)appealErrorLine.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000)
        }).catch((e)=>{
            if(appealErrorLine.current)appealErrorLine.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000)
        })

    }

    return(
        <ModalWindow onClose={() => onClose()}>
            <MainFormTemplate title={`Возврат по заказу [ ${orderId} ]`} maxWidth={"700px"} background={"white"}>
                <div className={"row mt-3"}>
                    <div className={"col-lg-6"}>
                        <InputItem
                            val={phone }
                            mode={"ei"}
                            info={"Телефон для связи"}
                            title={"Телефон"}
                            titleShift={0}
                            placeHolder={"Телефон"}
                            inputType={0}
                            regExp={/^((\+7)|(8)|(^))9[0-9]{9}$/ui}
                            onChange={(e)=>{
                                if(e?.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui))
                                {
                                    const rt = e?.match(/[0-9]{10}$/ui)
                                    if(rt) setPhone( `+7${rt[0]}`)
                                    return
                                }
                                setPhone(e)
                            }}
                        ></InputItem>
                    </div>
                    <div className={"col-lg-6"}>
                        <InputItem
                            val={eMail }
                            mode={"ei"}
                            info={"e-Mail для связи"}
                            title={"e-Mail"}
                            titleShift={-1}
                            placeHolder={"eMail"}
                            inputType={0}
                            regExp={/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ui}
                            onChange={(e)=>{
                                setEMail(e)
                            }}
                        ></InputItem>
                    </div>
                </div>
                <div className={"row mt-3"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={appeal}
                            mode={"ei"}
                            info={"Причина возврата"}
                            title={""}
                            titleShift={-6}
                            placeHolder={"Причина возврата"}
                            inputType={2}
                            lineCount={5}
                            onChange={(e)=>setAppeal(e)}
                        ></InputItem>
                    </div>

                </div>
                <div className={"row mt-3"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={payData}
                            mode={"ei"}
                            info={"Платежные реквизиты"}
                            title={""}
                            titleShift={-6}
                            placeHolder={"Платежные реквизиты для возврата"}
                            inputType={2}
                            lineCount={3}
                            onChange={(e)=>setPayData(e)}
                        ></InputItem>
                    </div>

                </div>

                <div className={styles.errCont}>
                    <ErrorLineItem ref={appealErrorLine}></ErrorLineItem>
                </div>

                <div className={"row"}>
                    <div className={styles.actCont} >

                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>handleSendAppeal()}
                            >Отправить</button>
                        </div>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>onClose()}
                            >Закрыть</button>
                        </div>

                        <div className={styles.ldrCont} >
                            <WaitLoader loading={ldrAddFeedback} api={rsAddFeedback} onlyLoading={true}>

                            </WaitLoader>
                        </div>

                    </div>


                </div>

            </MainFormTemplate>

        </ModalWindow>
    )
}